import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BBreadcrumb,
  BBreadcrumbItem,
  BFormGroup,
  BFormInput,
  BCardBody,
  BBadge,
  BAlert,
  BFormCheckbox,
  BFormTextarea, BTable, BDropdown, BDropdownItem, BPagination, BModal, BFormSelect,
  BCardText, BCardTitle, BForm, BInputGroup, BLink, BNavbarNav, BInputGroupAppend,
  BImg, BCardFooter, VBTooltip, BAvatar, BCardHeader, BNavItem,
  BTab, BTabs, BOverlay
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import vSelect from 'vue-select'
import mdiVue from 'mdi-vue/v2'
import * as mdijs from '@mdi/js'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('BRow', BRow)
Vue.component('BCol', BCol)
Vue.component('BCard', BCard)
Vue.component('BCardHeader', BCardHeader)
Vue.component('BCardText', BCardText)
Vue.component('BCardTitle', BCardTitle)
Vue.component('BCardBody', BCardBody)
Vue.component('BCardFooter', BCardFooter)
Vue.component('BButton', BButton)
Vue.component('BBreadcrumb', BBreadcrumb)
Vue.component('BBreadcrumbItem', BBreadcrumbItem)
Vue.component('BForm', BForm)
Vue.component('BFormGroup', BFormGroup)
Vue.component('BFormInput', BFormInput)
Vue.component('BInputGroup', BInputGroup)
Vue.component('BInputGroupAppend', BInputGroupAppend)
Vue.component('BBadge', BBadge)
Vue.component('BAlert', BAlert)
Vue.component('BFormCheckbox', BFormCheckbox)
Vue.component('BFormTextarea', BFormTextarea)
Vue.component('BTable', BTable)
Vue.component('BDropdown', BDropdown)
Vue.component('BDropdownItem', BDropdownItem)
Vue.component('BPagination', BPagination)
Vue.component('BModal', BModal)
Vue.component('BFormSelect', BFormSelect)
Vue.component('BLink', BLink)
Vue.component('BNavbarNav', BNavbarNav)
Vue.component('BNavItem', BNavItem)
Vue.component('BImg', BImg)
Vue.component('BAvatar', BAvatar)
Vue.component('BTab', BTab)
Vue.component('BTabs', BTabs)
Vue.component('BOverlay', BOverlay)

Vue.component('vSelect', vSelect)

Vue.directive('Ripple', Ripple)
Vue.directive('BTooltip', VBTooltip)
Vue.directive('heightFade', heightFade)

Vue.use(mdiVue, {
  icons: mdijs
})
